import { Directive, ElementRef, AfterViewInit } from '@angular/core';
import { setting } from '../../../../setting';

@Directive({
  selector: 'img[src]'
})
export class SecureImageDirective implements AfterViewInit {
  private httpOnlyUrls: string[] = [];
  
  constructor(private el: ElementRef) {
    this.httpOnlyUrls = this.collectHttpUrls(setting);
  }
  
  private collectHttpUrls(obj: any, urls: string[] = []): string[] {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const value = obj[key];
        if (typeof value === 'string' && value.startsWith('http://')) {
          const baseUrl = value.split('/api')[0];
          if (!urls.includes(baseUrl)) {
            urls.push(baseUrl);
          }
        } else if (typeof value === 'object' && value !== null) {
          this.collectHttpUrls(value, urls);
        }
      }
    }
    return urls;
  }
  
  private shouldKeepHttp(url: string): boolean {
    return this.httpOnlyUrls.some(httpUrl => url.startsWith(httpUrl));
  }
  
  ngAfterViewInit() {
    setTimeout(() => {
      const originalSrc = this.el.nativeElement.src;
      
      if (originalSrc && originalSrc.startsWith('http://')) {
        if (!this.shouldKeepHttp(originalSrc)) {
          this.el.nativeElement.src = originalSrc.replace('http://', 'https://');
        }
      }
    }, 0);
  }
}